import { Button } from '@calizahq/react-components-v2'
import pull from 'lodash/pull'
import React, { useEffect, useState } from 'react'

import { Checkbox, Dropdown } from '@/components'
import { FilterActions, useFiltersContext } from '@/context'
import { useMobile } from '@/hooks'
import { ScheduledCommunicationStatus } from '@/types/ScheduledCommunication'

export const ScheduledCommunicationStatusFilter = () => {
  const [{ scheduledCommunicationsFilters }, FilterDispatch] = useFiltersContext()
  const { scheduledCommunicationStatuses } = scheduledCommunicationsFilters
  const [filterScheduledCommunicationStatusOptions, setScheduledCommunicationStatusOptions] = useState<string[]>([])

  useEffect(() => {
    if (scheduledCommunicationStatuses) {
      setScheduledCommunicationStatusOptions(scheduledCommunicationStatuses)
    }
  }, [scheduledCommunicationStatuses])

  const [dropdownExpanded, setDropdownExpanded] = useState(false)
  const { isMobile } = useMobile()

  const scheduledCommunicationStatusOptions = Object.keys(ScheduledCommunicationStatus).map((key) => {
    return { label: ScheduledCommunicationStatus[key], value: ScheduledCommunicationStatus[key] }
  })

  const handleClick = (description: string) => {
    if (filterScheduledCommunicationStatusOptions.includes(description))
      setScheduledCommunicationStatusOptions(pull([...filterScheduledCommunicationStatusOptions], description))
    else setScheduledCommunicationStatusOptions([...filterScheduledCommunicationStatusOptions, description])
  }

  const handleApply = () => {
    setDropdownExpanded(false)
    FilterDispatch(
      FilterActions.setFilters({
        filterName: 'scheduledCommunications',
        filters: {
          scheduledCommunicationStatuses: filterScheduledCommunicationStatusOptions,
        },
      }),
    )
  }

  const handleResetFilters = () => {
    setDropdownExpanded(false)
    setScheduledCommunicationStatusOptions([])
    FilterDispatch(
      FilterActions.setFilters({
        filterName: 'scheduledCommunications',
        filters: {
          scheduledCommunicationStatuses: null,
        },
      }),
    )
  }

  const handleCancel = () => {
    setDropdownExpanded(false)
  }

  const renderButtons = () => {
    return (
      <div className="flex flex-row items-center justify-between px-6 pb-4 pt-4">
        {isMobile ? (
          <Button className="mr-4 flex-1 bg-grey-100" onClick={handleResetFilters} variant={'secondary'}>
            Reset
          </Button>
        ) : (
          <Button onClick={handleResetFilters} size="small" variant={'secondary'}>
            <span className="underline underline-offset-2">Reset</span>
          </Button>
        )}

        <Button
          className="flex-1 bg-text-semantic-success md:flex-0"
          onClick={handleApply}
          size={isMobile ? undefined : 'small'}
        >
          Apply
        </Button>
      </div>
    )
  }

  const renderHeader = () => {
    return (
      <div className="md:px-6 md:pt-6 md:mb-4">
        <h3 className="font-bold text-header-md">Status</h3>
      </div>
    )
  }

  return (
    <Dropdown
      displayedCount={filterScheduledCommunicationStatusOptions?.length ?? 0}
      expanded={dropdownExpanded}
      headerTitle="Status"
      onHideDropdown={handleCancel}
      renderFooter={renderButtons}
      renderHeader={renderHeader}
      selected={!!scheduledCommunicationStatuses}
      setExpanded={setDropdownExpanded}
    >
      <div className="md:w-120">
        <div className={`grid max-h-72 grid-cols-2 gap-x-14 gap-y-4 px-6 pb-6 md:overflow-auto`}>
          {scheduledCommunicationStatusOptions.map((val) => (
            <div
              className="flex cursor-pointer flex-row items-center"
              key={val.value}
              onClick={() => handleClick(val.value)}
              role="presentation"
            >
              <Checkbox
                checked={filterScheduledCommunicationStatusOptions.includes(val.value)}
                onClick={() => handleClick(val.value)}
              />
              <div className="text-sm">{val.label}</div>
            </div>
          ))}
          <div className="h-8 col-span-2 md:hidden" />
        </div>
      </div>
    </Dropdown>
  )
}
